/*
 * NYORD: Kaufbereich der Produktseite, nur mit „NYORD-Stil im Kaufbereich“. Dawn schreibt Preis und Knopftext bei jedem
 * Variantenwechsel neu (product-info.js), daher beobachten wir den Bereich und richten die Ersparnis-Pille wieder her.
 * Kein Preis im Warenkorb-Knopf (Tim, 18.10.2026): der Preis steht direkt darüber.
 */
(function () {
  // Ersparnis als Pille: Dawn rendert den Preis nach einem Variantenwechsel neu, das kleine Skript aus
  // snippets/discount-badge läuft dann nicht mehr, und der Badge zeigt nur „Rabatt“. Text aus der Markierung nehmen.
  function ersparnis(bereich) {
    var preis = bereich.querySelector('[id^="price-"]');
    var marke = preis && preis.querySelector('.discount-badge__injection[data-discount-text]');
    var badge = preis && preis.querySelector('.price__badge-sale');
    if (!badge) return;
    // Beim ersten Laden hat das Skript den Text schon gesetzt und die Markierung entfernt
    var soll = (marke ? marke.getAttribute('data-discount-text') : badge.textContent).trim().replace(/!$/, '');
    if (badge.textContent.trim() !== soll) badge.textContent = soll;
  }

  function auffrischen(bereich) {
    ersparnis(bereich);
    // Falls noch ein Preis aus einem älteren Stand im Knopf steht (Seiten-Cache), entfernen
    var alt = bereich.querySelector('.product-form__submit[name="add"] .nb-kauf__preis');
    if (alt) alt.remove();
  }

  function verbinden(bereich) {
    if (bereich.dataset.nbPreis) return;
    bereich.dataset.nbPreis = '1';
    var geplant = false;
    var beobachter = new MutationObserver(function () {
      if (geplant) return;
      geplant = true;
      requestAnimationFrame(function () {
        geplant = false;
        auffrischen(bereich);
      });
    });
    beobachter.observe(bereich, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['disabled'] });
    auffrischen(bereich);
  }

  // Galerie höher als der Bildschirm (Bühne, Signatur, Daumen): sie soll erst hochscrollen, bis ihre Unterkante
  // sichtbar ist, und dann kleben. Dafür die Höhe als CSS-Variable (assets/nb-produkt.css rechnet daraus „top“).
  function galerieHoehe() {
    document.querySelectorAll('.nb-pdp media-gallery').forEach(function (galerie) {
      var setzen = function () {
        galerie.style.setProperty('--nb-galerie-h', galerie.offsetHeight + 'px');
      };
      setzen();
      if ('ResizeObserver' in window) new ResizeObserver(setzen).observe(galerie);
    });
  }

  // Freisteller-Bühne: das Produkt füllt den Rahmen. Freisteller haben unterschiedlich viel durchsichtigen Rand;
  // wir messen das Produkt im Bild (Deckkraft) und setzen das Bild so, dass das Produkt eine feste Fläche füllt.
  // Mit Signatur stehen Produkt und Schriftzug als Gruppe mittig, der Schriftzug direkt unter dem Produkt.
  // Ohne lesbares Bild bleiben die Werte aus dem CSS.
  function buehnen() {
    document.querySelectorAll('.nb-pdp .nb-frei-buehne').forEach(function (buehne) {
      // Nur das Produktbild (direktes Kind), nicht das Testsiegel oder die Signatur
      var bild = buehne.querySelector(':scope > img');
      if (!bild) return;
      var sig = buehne.querySelector('.nb-signatur');
      var box = null;
      function messen() {
        try {
          var n = 160;
          var leinwand = document.createElement('canvas');
          leinwand.width = n;
          leinwand.height = n;
          var ctx = leinwand.getContext('2d', { willReadFrequently: true });
          ctx.drawImage(bild, 0, 0, n, n);
          var d = ctx.getImageData(0, 0, n, n).data;
          var x0 = n, y0 = n, x1 = -1, y1 = -1;
          for (var y = 0; y < n; y++) {
            for (var x = 0; x < n; x++) {
              if (d[(y * n + x) * 4 + 3] > 40) {
                if (x < x0) x0 = x;
                if (x > x1) x1 = x;
                if (y < y0) y0 = y;
                if (y > y1) y1 = y;
              }
            }
          }
          if (x1 > x0 && y1 > y0) box = [x0 / n, y0 / n, (x1 + 1) / n, (y1 + 1) / n];
        } catch (e) {
          box = null;
        }
      }
      function setzen() {
        if (!box) return;
        var w = buehne.clientWidth;
        var h = buehne.clientHeight;
        if (!w || !h) return;
        var sigH = sig ? sig.offsetHeight : 0;
        var abstand = sig ? h * 0.035 : 0;
        var nw = bild.naturalWidth || 1;
        var nh = bild.naturalHeight || 1;
        var pw = (box[2] - box[0]) * nw;
        var ph = (box[3] - box[1]) * nh;
        var maxB = w * 0.84;
        var maxH = sig ? h * 0.86 - sigH - abstand : h * 0.8;
        var k = Math.min(maxB / pw, maxH / ph);
        var bw = nw * k;
        var bh = nh * k;
        var produktB = pw * k;
        var produktH = ph * k;
        var produktOben = sig ? (h - (produktH + abstand + sigH)) / 2 - h * 0.01 : (h - produktH) / 2 - h * 0.03;
        var produktUnten = produktOben + produktH;
        bild.style.inset = 'auto';
        bild.style.left = Math.round((w - produktB) / 2 - box[0] * bw) + 'px';
        bild.style.top = Math.round(produktOben - box[1] * bh) + 'px';
        bild.style.width = Math.round(bw) + 'px';
        bild.style.height = Math.round(bh) + 'px';
        buehne.style.setProperty('--nb-schatten-top', Math.round(produktUnten - h * 0.04) + 'px');
        if (sig) buehne.style.setProperty('--nb-sig-top', Math.round(produktUnten + abstand) + 'px');
        buehne.classList.add('nb-frei--vermessen');
      }
      function los() {
        messen();
        setzen();
        if ('ResizeObserver' in window) {
          // auch die Signatur selbst: ihre Höhe ändert sich, sobald die Schreibschrift geladen ist
          var ro = new ResizeObserver(setzen);
          ro.observe(buehne);
          if (sig) ro.observe(sig);
        }
      }
      if (bild.complete && bild.naturalWidth) los();
      else bild.addEventListener('load', los, { once: true });
    });
  }

  // Tabs: Fett nur am Zeilenanfang (Überschriften wie „Reinigung und Pflege“, Bezeichnungen wie „Tiefe:“). Fett mitten
  // im Satz („kratzfest“, „den vollen Kaufbetrag.“) kommt aus alten SEO-Texten und wirkt zufällig (Tim 14.10.2026);
  // es wird normal gesetzt (Klasse nb-unfett), die Texte in Shopify bleiben unverändert.
  function zeilenAnfang(el, wurzel) {
    var n = el;
    while (n && n !== wurzel) {
      var s = n.previousSibling;
      while (s) {
        if (s.nodeName === 'BR') return true;
        if (s.textContent && s.textContent.trim()) return false;
        s = s.previousSibling;
      }
      var p = n.parentElement;
      if (!p || p === wurzel || /^(P|LI|DIV|TD|TH|H[1-6]|DD|DT|BLOCKQUOTE|UL|OL|TABLE|TR)$/.test(p.nodeName)) return true;
      n = p;
    }
    return true;
  }
  function tabFett() {
    document.querySelectorAll('.nb-pdp .nb-tab__inhalt').forEach(function (wurzel) {
      wurzel.querySelectorAll('strong, b').forEach(function (f) {
        if (f.closest('h1, h2, h3, h4, h5, h6')) return;
        if (!zeilenAnfang(f, wurzel)) f.classList.add('nb-unfett');
      });
    });
  }

  // Testsiegel (snippets/nb-siegel) kippt beim Überfahren leicht in 3D: die Seite unter der Maus gibt nach, ein
  // Lichtpunkt folgt ihr. Das Siegel lässt Klicks durch (pointer-events: none), daher messen wir die Maus am Dokument
  // gegen die ungekippte Außenfläche. Nur mit Maus und ohne „Bewegung reduzieren“; auf dem Handy steht es still.
  function siegelKippen() {
    if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var MAX = 12;
    var RAND = 24;
    var punkt = null;
    var geplant = false;
    function setzen(siegel, nx, ny) {
      var karte = siegel.querySelector('.nb-siegel__karte');
      if (!karte) return;
      if (nx === null) {
        siegel.classList.remove('nb-siegel--kippt');
        karte.style.removeProperty('--nb-kipp-x');
        karte.style.removeProperty('--nb-kipp-y');
        karte.style.removeProperty('--nb-kipp-s');
        return;
      }
      siegel.classList.add('nb-siegel--kippt');
      karte.style.setProperty('--nb-kipp-y', ((nx - 0.5) * 2 * MAX).toFixed(2) + 'deg');
      karte.style.setProperty('--nb-kipp-x', (-(ny - 0.5) * 2 * MAX).toFixed(2) + 'deg');
      karte.style.setProperty('--nb-kipp-s', '1.04');
      karte.style.setProperty('--nb-glanz-x', ((nx - 0.5) * 50).toFixed(1) + '%');
      karte.style.setProperty('--nb-glanz-y', ((ny - 0.5) * 50).toFixed(1) + '%');
    }
    function takt() {
      geplant = false;
      document.querySelectorAll('.nb-siegel--buehne, .nb-siegel--spot').forEach(function (siegel) {
        var r = siegel.getBoundingClientRect();
        var drin =
          punkt &&
          r.width > 0 &&
          punkt.x > r.left - RAND &&
          punkt.x < r.right + RAND &&
          punkt.y > r.top - RAND &&
          punkt.y < r.bottom + RAND;
        if (!drin) {
          if (siegel.classList.contains('nb-siegel--kippt')) setzen(siegel, null);
          return;
        }
        var nx = Math.min(1, Math.max(0, (punkt.x - r.left) / r.width));
        var ny = Math.min(1, Math.max(0, (punkt.y - r.top) / r.height));
        setzen(siegel, nx, ny);
      });
    }
    function planen() {
      if (geplant) return;
      geplant = true;
      requestAnimationFrame(takt);
    }
    document.addEventListener(
      'pointermove',
      function (e) {
        if (e.pointerType === 'touch') return;
        punkt = { x: e.clientX, y: e.clientY };
        planen();
      },
      { passive: true }
    );
    // Maus verlässt das Fenster: alles gerade stellen
    document.addEventListener('pointerout', function (e) {
      if (e.relatedTarget) return;
      punkt = null;
      planen();
    });
  }

  function start() {
    document.querySelectorAll('.nb-pdp .product__info-container').forEach(verbinden);
    galerieHoehe();
    buehnen();
    tabFett();
    siegelKippen();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
